import { PAGE_PARAM } from '@/app/lib/constants'

import { READABLE_FILTER_PARAMS } from '@/app/entradas/(general-web)/recintos/[location]/[url]/_components/constants'

/**
 * Orden fijo de los 2 selectores de `fields` que quedan tras sacar Precio a
 * `rangeField` (revisado — mismo mecanismo que Promociones/Lo más vendido/
 * Subcategoría): Ordenar por → Categoría. El `onApply` genérico de
 * `ListingFilters` entrega los valores del borrador por posición, así que
 * este orden traduce cada posición a su query param real.
 */
export const FIELD_ORDER = ['sort', 'genre'] as const

function withoutPage(currentSearch: string): URLSearchParams {
  const next = new URLSearchParams(currentSearch)
  next.delete(PAGE_PARAM)
  return next
}

function compose(pathname: string, params: URLSearchParams): string {
  const qs = params.toString()
  return qs ? `${pathname}?${qs}` : pathname
}

function setOrDelete(params: URLSearchParams, key: string, value: string | undefined) {
  if (value) params.set(key, value)
  else params.delete(key)
}

/**
 * URL al aplicar el borrador del SideSheet: los 2 selectores restantes como
 * query params (no hay ningún campo de segmento de ruta en esta página — el
 * recinto ya tiene una ubicación fija); resetea `page`. `applied` viene en
 * el orden de `FIELD_ORDER`. Precio ya no entra (aplicación instantánea,
 * fuera del borrador — ver `rangeField` en `RecintoEventsFilters.tsx`).
 */
export function buildApplyHref(pathname: string, applied: readonly string[], currentSearch: string): string {
  const next = withoutPage(currentSearch)
  setOrDelete(next, READABLE_FILTER_PARAMS.sort, applied[FIELD_ORDER.indexOf('sort')])
  setOrDelete(next, READABLE_FILTER_PARAMS.genre, applied[FIELD_ORDER.indexOf('genre')])
  return compose(pathname, next)
}
